import env from './env';

export default {
  deriveIterations: env('ENCRYPTION_DERIVE_ITERATIONS', 120_012),
  deriveHashMethod: env('ENCRYPTION_DERIVE_HASH_METHOD', 'SHA-512'),
};
